
// native
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  navigationOpened$: Subject<void> = new Subject<void>();
  navigationHidden$: Subject<boolean> = new Subject<boolean>();

  isParameterizedRoute: boolean = false;

  getChildRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
